import { Suspense } from "react";
import HotpleLogo from "@/components/hotple-logo";
import Div from "@/components/ui/div";
import { ROUTES } from "@/constants/routes";
import Link from "next/link";

const UL_HeaderUnprotected = () => {
  return (
    <Div
      className={
        "sticky top-0 left-0 flex items-center justify-between gap-4 z-40 border-b dark:border-neutral-800 border-neutral-200 "
      }
    >
      <Link href={ROUTES.current.play}>
        <div className="block cursor-pointer">
          <HotpleLogo />
        </div>
      </Link>
    </Div>
  );
};

export default function Header() {
  return (
    <Suspense fallback={<></>}>
      <UL_HeaderUnprotected />
    </Suspense>
  );
}
